module.exports = __webpack_public_path__ + "static/media/Bg_header.065f0851.jpg";